import { render, staticRenderFns } from "./SuggestionCard.vue?vue&type=template&id=0a9a04a2&scoped=true"
import script from "./SuggestionCard.vue?vue&type=script&lang=js"
export * from "./SuggestionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9a04a2",
  null
  
)

export default component.exports